var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 141,
    viewBox: "0 0 139 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.856 65.7172H99.7371H85.8253V18.3748C102.76 23.5728 116.255 36.6207 122.067 53.2755H136.1C128.394 25.2322 103.45 4.31909 73.376 2.64453V11.5402V16.0713V78.1666H81.673H85.8253H124.787C122.196 100.33 106.594 118.508 85.8253 124.88V90.8584H73.376V127.184V130.881V140.61C109.724 138.587 138.57 108.475 138.57 71.6275C138.565 69.6372 138.479 67.6671 138.313 65.7172H124.856Z",
    fill: "url(#paint0_linear_173_73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.054 83.3266C134.956 84.5844 134.069 87.5471 133.175 90.2825C125.446 117.886 100.116 138.14 70.0494 138.14C67.6601 138.135 65.3035 138.006 62.9799 137.754C27.8671 134.48 0.376953 104.952 0.376953 68.9829C0.376953 32.135 29.2234 2.02312 65.5713 0V75.5221H14.1599C16.1603 92.6541 25.9501 107.407 39.8845 116.159C41.256 116.803 42.4987 117.416 43.4534 118.007C43.5898 118.053 59.0776 123.41 66.7306 115.749C74.4139 108.066 80.415 105.058 89.144 104.437C97.8729 103.815 106.178 95.9199 108.466 94.8818C110.754 93.8438 112.679 103.27 94.1525 114.454C103.222 117.159 121.764 99.0341 127.795 88.4412C133.812 77.8407 135.259 80.7049 135.054 83.3266ZM14.0917 63.0727H53.1219V15.7303C32.1558 22.1633 16.4558 40.629 14.0917 63.0727Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.054 85.9711C134.956 87.2289 134.069 90.1916 133.175 92.927C125.446 120.531 100.116 140.785 70.0494 140.785C67.6601 140.78 65.3035 140.651 62.9799 140.398C27.8671 137.125 0.376953 107.596 0.376953 71.6274C0.376953 34.7795 29.2234 4.67522 65.5713 2.64453V78.1666H14.1599C16.1603 95.2987 25.9501 110.051 39.8845 118.803C41.256 119.447 42.4987 120.061 43.4534 120.652C43.5898 120.697 59.0776 126.055 66.7306 118.402C74.4139 110.711 80.415 107.703 89.144 107.081C97.8729 106.46 106.178 98.5644 108.466 97.5263C110.754 96.4883 112.679 105.914 94.1525 117.106C103.222 119.803 121.764 101.679 127.795 91.0857C133.812 80.4852 135.259 83.3494 135.054 85.9711ZM14.0917 65.7172H53.1219V18.3748C32.1558 24.8079 16.4558 43.2735 14.0917 65.7172Z",
    fill: "url(#paint1_linear_173_73)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_73",
    x1: -42.6834,
    y1: 116.425,
    x2: -52.5722,
    y2: 26.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#2BAAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#1A75BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#293B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_73",
    x1: 24.6771,
    y1: 187.02,
    x2: -63.1197,
    y2: 40.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#282460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#2BAAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#293B8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.60364aebc0d242667129e23d72c2942e.svg";
export { ForwardRef as ReactComponent };